export const capitalize = (val: string): string => !val ? val : val[0].toUpperCase() + val.substring(1);